import React,{Component} from 'react';
import * as routes from "../../../constants/routes";
import {connect} from "react-redux";

import './errorPage.scss';

//assets
import notFound from 'assets/mock/notFound.svg';
import notFoundDesktop from 'assets/mock/not_found_desktop.svg';


class Error extends Component{

    render(){

        return(
            <div className="page404">
                <img className='img' src={this.props.deviceState === 'mobile' ? notFound : notFoundDesktop} alt='/'/>
                <div className='wrapper'>
                    <h3 className='message'>{this.props.deviceState === 'mobile' ? this.props.text['error_page_msg_mobile'] : this.props.text['error_page_msg']}</h3>
                    <button className='home_btn' onClick={() => this.props.history.push(routes.home)}>{this.props.text['error_page_btn']}</button>
                </div>
            </div>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Error);